import type { InspectorDetail, TeamResponse } from './types';

// Same origin in production (we deploy this app onto inspectvault.com so
// /api/public/* resolves locally). Override at build time with VITE_API_BASE
// if pointing at a different host.
const API_BASE = (import.meta.env.VITE_API_BASE ?? '').replace(/\/$/, '');

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`HTTP ${res.status} ${res.statusText} for ${path}`);
  return res.json() as Promise<T>;
}

export function fetchTeam(): Promise<TeamResponse> {
  return getJson<TeamResponse>('/api/public/team');
}

// Inspector detail (incl. Google reviews) — bearer-gated on the external
// surface today. Lives on /api/external/inspectors/:slug and requires
// the inspect.ca origin to either proxy server-side or for IV to expose
// a no-auth alias. For Phase 2 we render just the team-list payload;
// per-inspector reviews come in Phase 3 once we add the public alias.
export function fetchInspector(slug: string): Promise<InspectorDetail> {
  return getJson<InspectorDetail>(`/api/public/team/${encodeURIComponent(slug)}`);
}
